<div class="infoblok">
  <i class="icon-info"></i>
  <p class="bodySmallContent" [innerHTML]="infoText"></p>
</div>
